import { CSSProperties, useEffect, useState } from "react";
import { Modal } from "../../../../../Modal/Default/Index";
import { ButtonOnlyTitle } from "../../../../../Buttons/ButtonOnlyTitle/Index";
import { useTaskCreation } from "../../../../../../hooks/useTaskCreation";
import { RoundedCloseButton } from "../../../../../Buttons/RoundedCloseButton/Index";
import axios from "../../../../../../services/axios";
import { useFilter } from "../../../../../../hooks/useFilter";

const createEvaluatorModalStyle = {
  padding: "50px",
  width: "600px",
  height: "fit-content",
  borderRadius: 20,
  position: "relative"
} as CSSProperties;

export default function CancelateEvaluation() {
  const { modalCancelateEvaluation, setModalCancelateEvaluation, taskId } = useTaskCreation();
  const { reloadTasks, setReloadTasks } = useFilter()

  return (
    <>
      <Modal
        visible={modalCancelateEvaluation}
        contentStyle={createEvaluatorModalStyle}
      >
        <div className="closeButton__startEvaluation">
          <RoundedCloseButton
            onClick={() => setModalCancelateEvaluation(false)}
          />
        </div>
        <section className="body__startEvaluation">
          <header>
            <h2 className="title__startEvaluation">Cancelar avaliação</h2>
            <span className="description__startEvaluation">Ao cancelar a avaliação, a tarefa sera removida para o avaliador atribuido.</span>
          </header>
          <footer className="footerCreateEvaluator">
            <ButtonOnlyTitle
              title="Cancelar"
              theme="light"
              type="button"
              onClick={() => {
                setModalCancelateEvaluation(false)
                setReloadTasks(0)
              }}
            />
            <ButtonOnlyTitle
              title="Confirmar"
              theme="info"
              type="button"
              onClick={() => {
                axios.put(`/tasks/cancel/${taskId}`).finally(() => {
                  setModalCancelateEvaluation(false)
                  setReloadTasks(taskId)
                })
              }}
            />
          </footer>
        </section>
      </Modal>
    </>
  )
}